export const MAIN_CLASS_NAME = 'project-source-previewing';
export const ROLLING_CLASS_NAME = `${MAIN_CLASS_NAME}_rolling`;
export const HEADER_CLASS_NAME = `${MAIN_CLASS_NAME}__header`;
export const FOOTER_CLASS_NAME = `${MAIN_CLASS_NAME}__footer`;
